// Visibility tiers — single client-side source of truth (was copy-pasted in
// Vault, Today, Align and PeoplePane). Mirrors the server's TIER_ORDER.

export const TIERS = ['private', 'spouse', 'family', 'close_friends', 'colleagues', 'public'] as const;
export type Tier = (typeof TIERS)[number];

/** Chip styling per tier (border + text). */
export const TIER_COLOR: Record<string, string> = {
  private: 'text-amber border-amber/40',
  spouse: 'text-rose-300 border-rose-300/30',
  family: 'text-emerald-300 border-emerald-300/30',
  close_friends: 'text-sky-300 border-sky-300/30',
  colleagues: 'text-yellow-200 border-yellow-200/30',
  public: 'text-ink/60 border-ink/20',
};

/** Display label + Align-style chip class; shared tiers can be bulk-confirmed. */
export const TIER_META: Record<string, { label: string; cls: string; shared?: boolean }> = {
  public: { label: 'public', cls: 'text-sky-300 border-sky-300/40', shared: true },
  colleagues: { label: 'colleagues', cls: 'text-sky-300 border-sky-300/40', shared: true },
  close_friends: { label: 'close friends', cls: 'text-ink/55 border-ink/20' },
  family: { label: 'family', cls: 'text-ink/55 border-ink/20' },
  spouse: { label: 'spouse', cls: 'text-ink/55 border-ink/20' },
  private: { label: 'private', cls: 'text-amber/70 border-amber/30' },
};

export function tierLabel(t: string): string {
  return TIER_META[t]?.label ?? t.replace('_', ' ');
}
